import { useTranslation } from "@outschool/localization";
import React from "react";

import { Message } from "../components/Message";
import { Sender } from "../consts";

export const ConciergeChatMessage = () => {
  const { t } = useTranslation("client\\components\\chat\\conciergeChat");

  return (
    <Message
      text={t`
Hi there! Welcome to the Outschool Concierge 👋

Tell us a bit about your kid and what you’re looking for and we’ll send you some personalized class recommendations!

Helpful things to include (whatever you can share is great):
• Your child’s name and age (if you already have a learner profile set up, you can select your child’s name)
• Your availability & timezone
• Class format (live, 1-on-1, small group)
• Topics your child loves (from dinosaurs to drawing, anything goes)
• Teaching approach that works best (energetic & playful or calm & structured)
• Any learning goals or needs you have for your child

We’re here to help. If you’re not sure about something, just let us know!
`.trim()}
      sender={Sender.System}
    />
  );
};
